var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"search-input-container"},[_c('el-input',{attrs:{"value":_vm.value,"placeholder":"搜索..."},on:{"input":_vm.handleInput}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }